import { z } from 'zod';
import {
  optionalDateSchema,
  optionalPositiveIdSchema,
  optionalTextSchema,
} from '@/utils/searchParams';
import { APPROVAL_STATUS, LEAVE_REQUEST_TYPE } from '../constants/leaveApplication.constants';

export type LeaveApplicationFilters = Record<string, string>;

export const leaveApplicationSearchSchema = z.object({
  dateFrom: optionalDateSchema,
  dateTo: optionalDateSchema,
  leaveStatus: z.enum(APPROVAL_STATUS).optional().catch(undefined),
  requestType: z.enum(LEAVE_REQUEST_TYPE).optional().catch(undefined),
  leaveTypeId: optionalPositiveIdSchema,
  amUserId: optionalPositiveIdSchema,
  zmUserId: optionalPositiveIdSchema,
  divisionId: optionalPositiveIdSchema,
  districtId: optionalPositiveIdSchema,
  thanaId: optionalPositiveIdSchema,
  search: optionalTextSchema,
});

export type LeaveApplicationSearch = z.infer<typeof leaveApplicationSearchSchema>;
